// extracted by mini-css-extract-plugin
export default {"card":"Card_card__z8HfQ","secondary":"Card_secondary__ouxn2","header":"Card_header__0kuXG","left":"Card_left__sU-TG","titleContainer":"Card_titleContainer__4Lztg"};